import { FC, useEffect } from "react";
import AddProductProvider from "../memory/memr";
import InitMiddlewareAddBanners from "../middlewares/initMiddleware";
import store from "../../../store/store";
import { fetchAllOffers } from "../../Offers/reducer/offerSlice";
import { motion } from "framer-motion";

const AddBannerInstance: FC<{}> = () => {
  useEffect(() => {
    store.dispatch(fetchAllOffers(null));
  }, []);
  return (
    <AddProductProvider>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <InitMiddlewareAddBanners />
      </motion.div>
    </AddProductProvider>
  );
};

export default AddBannerInstance;
